<template>
  <div>
    <!-- 发票管理 -->
    <div class="name">
      HSCODE
    </div>
    <!-- 编码 -->
    <div class="row">
      <div class="label">{{ $t('message.code') }}:</div>
      <div class="value">
        <el-input v-model="detail.client_product_clearance.hscode"></el-input>
      </div>
      <!-- 选择编码 -->
      <el-button type="primary" @click="selectEncoding">{{ $t('message.selectEncoding') }}</el-button>
    </div>
    <!-- 品名 -->
    <div class="row">
      <div class="item">
        <!-- 品名 -->
        <div class="name">
          {{ $t('message.material') }}
        </div>
      </div>
      <div class="item">
        <!-- 材质 -->
        <div class="name">
          {{ $t('message.texture') }}
        </div>
      </div>
      <div class="item">
        <!-- 用途 -->
        <div class="name">
          {{ $t('message.use') }}
        </div>
      </div>
    </div>
    <!-- 日文 -->
    <div class="row">
      <div class="item">
        <!--  -->
        <div class="label">{{ $t('message.Japanese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.pingming_ja"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.Japanese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.material_ja"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.Japanese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.desc_ja"></el-input>
        </div>
      </div>
    </div>
    <!-- 中文 -->
    <div class="row">
      <div class="item">
        <!--  -->
        <div class="label">{{ $t('message.Chinese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.pingming_zh"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.Chinese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.material_zh"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.Chinese') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.desc_zh"></el-input>
        </div>
      </div>
    </div>
    <!-- 英文 -->
    <div class="row">
      <div class="item">
        <!--  -->
        <div class="label">{{ $t('message.english') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.pingming_en"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.english') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.material_en"></el-input>
        </div>
      </div>
      <div class="item">
        <div class="label">{{ $t('message.english') }}:</div>
        <div class="value">
          <el-input v-model="detail.client_product_clearance.desc_en"></el-input>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- HSCODE编码查询 -->
    <el-dialog :title="$t('message.hscodeCodeQuery')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="800px" center>
      <div class="row">
        <div class="value">
          <el-input v-model="hscode" style="width: 200px; margin-right: 10px;"></el-input>
          <!-- 查找 -->
          <el-button type="primary" @click="searchHscodeOption">{{ $t('message.lookup') }}</el-button>
        </div>
        <div class="value">* 请输入购买商品相关联的品名进行HSCODE匹配，在所有结果中您可以选择最合适的材质与品名</div>
      </div>
      <div class="table">
        <ol>
          <li>HSCODE</li>
          <!-- 材质 -->
          <li>
            {{ $t('message.texture') }}
          </li>
          <!-- 关税率 -->
          <li>
            {{ $t('message.tariffRate') }}
          </li>
          <!-- 操作 -->
          <li>
            {{ $t('message.operation') }}
          </li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <li> {{ item.hsCode }}</li>
          <!-- 材质 -->
          <li>
            {{ item.descriptionCN }}
          </li>
          <!-- 关税率 -->
          <li>
            {{ item.rate }}
          </li>
          <!-- 操作 -->
          <li>
            <el-button type="primary" @click="choose(item)"> {{ $t('message.choose') }}</el-button>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {
        client_product_clearance: {},
      },
      list: [],
      dialogVisible: false,
      hscode: '',
    };
  },
  methods: {
    // 设置数据
    setData(sys_code_set) {
      let datas = {
        sys_code_set,
        ...this.detail.client_product_clearance
      }
      this.$api.productManagementApi.batchUpdateInvoice(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //选择编码
    selectEncoding() {
      this.hscode = ''
      this.dialogVisible = true
      this.list = []
    },
    // 选择
    choose(item) {
      this.detail.client_product_clearance.hscode = item.hsCode
      this.dialogVisible = false
      this.$forceUpdate()
    },
    //通关编码查询
    searchHscodeOption() {
      let datas = {
        // user_id: this.detail.user_id,
        keywords: this.hscode,

      }
      this.$api.productManagementApi.searchHscodeOption(datas).then(res => {
        this.list = res.data.tariff_option.obj
        console.log(res);

      })
    },
  }
}
</script>
<style lang='scss' scoped>
.name {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  margin-bottom: 24px;
}

.row {
  display: flex;
  margin-bottom: 40px;

  .item {
    display: flex;
    margin-right: 40px;
    width: 342px;
  }

  .label {
    width: 100px;
    line-height: 40px;
  }

  .value {
    margin: 0 20px;
    display: flex;
  }
}
</style>